import { crossFetch, AbortController } from './fetch';

const DEFAULT_TIMEOUT = 30000; //30s

const fetchWithTimeout = (url, timeout = DEFAULT_TIMEOUT, options = {}) => {
    const controller = new AbortController();

    const timeoutId = setTimeout(() => controller.abort(), timeout);

    return new Promise((resolve, reject) => {
        crossFetch(url, { ...options, signal: controller.signal })
            .then((resp) => {
                clearTimeout(timeoutId);

                return resolve(resp);
            })
            .catch((err) => {
                if (err.name === 'AbortError') {
                    return reject(new Error('timeout'));
                }

                clearTimeout(timeoutId);

                return reject(err);
            });
    });
};

export default fetchWithTimeout;
